// these libraries below must be in the root.
import { HttpClientJsonpModule, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// modules
import { AppRoutingModule } from './app-routing.module';
import { AuthConfigModule } from './auth-config.module';
import { AppSharedModule } from './modules/app-shared.module';

// services and guards
import { JwtInterceptor } from './shared/helpers/jwt.interceptor';
import { AuthenticationService } from './shared/services/authentication.service';
import {
  AlertService, ApiCredentialsService, AuthorizationService, CustomerService, LoggingService, SettingsService, StorageManagerService, TemplateService
} from './shared/services/index';
import { AbsoluteSessionTimeoutService } from './shared/services/session-timeout-absolute.service';
import { SessionTimeoutService } from './shared/services/session-timeout.service';

// components
import {
  AccessdeniedComponent, ApiCredentialsComponent, AppComponent, CheckboxComponent, CompanyDatascopeSelectorComponent, CustomerSelectorComponent, DashboardComponent, DateComponent, DropdownComponent, DynamicformbuilderComponent, DynamicformsComponent, ErrorComponent, 
  FooterComponent, ForbiddenComponent, HeaderComponent, HomeComponent, IngestedDevicesChartComponent, NavMenuComponent, RadioComponent, SubmittedDevicesChartComponent, SupportComponent, TextboxComponent, UnauthorizedComponent
} from './components/index';

// Pipes
import { SplitWordsPipe } from './pipes/split-words.pipe';
import { UtcToLocalePipe } from './pipes/utc-to-locale.pipe';

// globals
import { AppGlobals } from './shared/globals/appGlobals';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    SupportComponent,
    ErrorComponent,
    DashboardComponent,
    DynamicformsComponent,
    DynamicformbuilderComponent,
    CheckboxComponent,
    DropdownComponent,
    RadioComponent,
    TextboxComponent,
    DateComponent,
    AccessdeniedComponent,
    CustomerSelectorComponent,
    UnauthorizedComponent,
    ForbiddenComponent,
    CompanyDatascopeSelectorComponent,
    ApiCredentialsComponent,
    IngestedDevicesChartComponent,
    SubmittedDevicesChartComponent,
    SplitWordsPipe,
    UtcToLocalePipe
  ],
  imports: [
    AppRoutingModule,
    HttpClientJsonpModule,
    AuthConfigModule,
    AppSharedModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    StorageManagerService,
    SettingsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    AlertService,
    AuthenticationService,
    LoggingService,
    CustomerService,
    TemplateService,
    AuthorizationService,
    HttpClientModule,
    SessionTimeoutService,
    AbsoluteSessionTimeoutService,
    AppGlobals,
    ApiCredentialsService,
    SettingsService,
    StorageManagerService,
    AlertService, ApiCredentialsService, AuthorizationService, CustomerService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
